import { ProposalsAPI } from './../../../api/proposals.api';
import { SessionStorageService } from './../../../services/session-storage.service';
import { Component, Input, OnInit } from "@angular/core";
import { MyToasterService } from '../../../services/my-toaster.service';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProcessService } from '../../../services/process.service';
import { UsersAPI } from '../../../api/users.api';

@Component({
    selector: 'modal-newsimulator',
    templateUrl: 'modal-newsimulator.component.html',
    styleUrls: ['modal-newsimulator.component.scss'],
})

export class ModalNewSimulatorComponent implements OnInit{

    /**
     * Recebe o objeto da simulação
     */
    @Input('Simulacao') Simulacao: any;

    /**
     * Variavel de controle para mostrar o formulário
     */
    public toOthers: boolean = false;

    public isModal = false;
    /**
     * Dados formulário
     */
    private Usuario: any = {
        'nome': '',
        'email': '',
        'telefone': '',
        'origem': 'S',
        'indicado': 0, // quando for para terceiros this.session.getUserId()
        'cidade': 0,//cidadeid
        'estado': '',
        'valorFinanciamento': 0,
        'valorImovel': 0,
    };
    /**
     * Dados formulário clear
     */
    private clearUsuario: any = Object.assign({}, this.Usuario);
    /** 
     * Variavel de controle de submissão
     */
    private submitted: boolean = false;

    constructor(
        private session: SessionStorageService,
        private ProposalsAPI: ProposalsAPI,
        public myToaster: MyToasterService,
        private activeModal: NgbActiveModal,
        public processService: ProcessService,
        public usersAPI: UsersAPI,
        private	router: Router,
    ) {
    }
    async ngOnInit(){
        let dados = await this.usersAPI.get();

        //Se for o modal de edicao criado pelo botao Simular
        if(this.isModal){
            //salva pra ele mesmo
            this.toOthers = false;
            this.saveSimulation();
            //alterar para eventemmitter atualizado a tabela
            window.location.reload();
        }
    }
    /**
     * saveSimulation
     * 
     * Envia simulação
     */
    async saveSimulation() {

        if (this.toOthers == false) {
            
            this.Usuario['nome'] = this.session.getUserName();
            this.Usuario['email'] = this.session.getEmail();
            this.Usuario['telefone'] = '';

            // Verifica se é o admin
            if(this.session.getUserGroupId() == 1 || this.session.getUserGroupId() == 3) {

                // Verifica se está setado o usuario
                if(this.processService.usuario.Email) {
                    this.Usuario['nome'] = this.processService.usuario.Nome;
                    this.Usuario['email'] = this.processService.usuario.Email;
                
                }
            }
        }
        //Fake name to insert data only
        // this.Usuario['nome'] = this.session.getUserName();
        this.Usuario['indicado'] = (this.toOthers == true) ? this.session.getUserId() : 0; // quando for para terceiros this.session.getUserId()
        this.Usuario['cidade'] = (this.Simulacao && this.Simulacao.cidade) ? this.Simulacao.cidade : 0;//cidadeid
        this.Usuario['estado'] = (this.Simulacao && this.Simulacao.uf) ? this.Simulacao.uf : '';
        this.Usuario['valorFinanciamento'] = (this.Simulacao && this.Simulacao.valorFinanciamento) ? this.Simulacao.valorFinanciamento : 0;
        this.Usuario['valorImovel'] = (this.Simulacao && this.Simulacao.valorImovel) ? this.Simulacao.valorImovel : 0;

        //regex mask phone
        this.Usuario['telefone'] = (this.Usuario['telefone']).toString().replace(/\(|\)|\-|\.| /g,'');
        
        let data = {
            Simulacao: this.Simulacao,
            Usuario: JSON.stringify(this.Usuario)
        }
        try {
            let dadosSalvos = await this.ProposalsAPI.save(data);
            this.myToaster.showSuccessToast('Simulação', 'Salva com sucesso!');

            // apos o sucesso resetamos o formulário ao estado original
            //oculta o formulário
            this.toOthers = false;
            //reseta o form
            this.Usuario = Object.assign({}, this.clearUsuario);
            //reseta a validação do formulario
            this.submitted = true;

            //Fecha o modal
            this.activeModal.close();

            if(this.session.getUserGroupId() == 2){

                this.router.navigate(['pages/simulations/list']);
            }
            else{      
                this.router.navigate(['pages/process/'+dadosSalvos.ProcessoId+'/simulations']);
            }

        } catch (e) {
            console.error(e);
            this.myToaster.showErrorToast('Simulação', 'Simulação já foi salva anteriormente');
        }

    }

    /**
     * onSubmit
     * 
     * Envia formulário
     * @param form dados formulário
     */
    onSubmit(form) {
        this.submitted = true;
        if (form.valid) {
            this.saveSimulation();
        }
    }

    // faz validação se há erros e retorna a classe de erro para sinalizar no input
    public validateCss(input) {
        if (this.submitted) {
            return { 'form-control-danger': !input.valid }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/modal-newsimulator/modal-newsimulator.component.ts